module.exports = __webpack_public_path__ + "static/img/20605564.7913dceb.png";